// src/api/adminSupplierApi.ts
import axios from "axios";

const API_BASE_URL = "https://api.thunderbirdsmoke.net";

export const authHeader = () => {
  const token = localStorage.getItem("authToken");
  if (!token) throw new Error("No auth token found");
  return { Authorization: `Bearer ${token}` };
};

export const fetchSuppliers = async () => {
  const res = await axios.get(`${API_BASE_URL}/api/admin/suppliers`, {
    headers: authHeader(),
  });
  return res.data.suppliers;
};

export const createSupplier = async (payload: {
  name: string;
  email?: string;
  phone?: string;
  address?: string;
}) => {
  const res = await axios.post(`${API_BASE_URL}/api/admin/suppliers`, payload, {
    headers: authHeader(),
  });
  return res.data;
};

export const updateSupplier = async (
  id: number,
  payload: {
    name?: string;
    email?: string;
    phone?: string;
    address?: string;
  }
) => {
  const res = await axios.put(`${API_BASE_URL}/api/admin/suppliers/${id}`, payload, {
    headers: authHeader(),
  });
  return res.data;
};

export const deleteSupplier = async (id: number) => {
  const res = await axios.delete(`${API_BASE_URL}/api/admin/suppliers/${id}`, {
    headers: authHeader(),
  });
  return res.data;
};

export const searchSuppliers = async (query: string) => {
  const res = await axios.get(`${API_BASE_URL}/api/admin/suppliers/search`, {
    params: { query },
    headers: authHeader(),
  });
  return res.data.suppliers; // [{ id, name }]
};


export const getProductSuppliers = async (productId: number) => {
  const res = await axios.get(`${API_BASE_URL}/api/admin/suppliers/by-product/${productId}`, {
    headers: authHeader(),
  });
  return res.data.suppliers;
};

export const assignSuppliersToProduct = async (payload: {
  product_id: number;
  supplier_ids: number[];
  primary_supplier_id: number | null;
}) => {
  const res = await axios.patch(
    `${API_BASE_URL}/api/admin/suppliers/assign`,
    payload,
    {
      headers: {
        "Content-Type": "application/json",
        ...authHeader(),
      },
    }
  );
  return res.data;
};

export const getAllProductsWithSuppliers = async () => {
  const res = await axios.get(`${API_BASE_URL}/api/admin/suppliers/products-with-suppliers`, {
    headers: authHeader(),
  });
  return res.data.products;
};
